import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { PriorAuthQueueComponent } from '../../prior-auth-queue/prior-auth-queue.component';
import { DraftEformsQueueComponent } from '../../eform-queues/draft-eforms-queue/draft-eforms-queue.component';
import { SubmittedEformsQueueComponent } from '../../eform-queues/submitted-eforms-queue/submitted-eforms-queue.component';

@Component({
  selector: 'app-utilization-reviewer-dashboard',
  templateUrl: './utilization-reviewer-dashboard.component.html',
  styleUrls: ['./utilization-reviewer-dashboard.component.scss'],
  imports: [MatCardModule, MatTabsModule, PriorAuthQueueComponent, DraftEformsQueueComponent, SubmittedEformsQueueComponent],
     
})
export class UtilizationReviewerDashboardComponent {
  selectedTabIndex: number;
  @Input() redirectToTabIndex: number;
}
